import React from 'react';
import { Footer2Component } from '../components/footer/footer2-component';
import style from '../styles/syaratketentuanPageStyle.module.css';
const SyaratKetentuan = () => {
  return (
    <>
      {/* <!DOCTYPE html> */}
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta
            name="facebook-domain-verification"
            content="rf11ik7ron1gr3x0tb5fk6q63ehvik"
          />
          <meta
            name="description"
            content="Platform agensi properti digital modern yang memudahkan kamu dalam proses pencarian properti impian dengan memilih agen yang kamu inginkan"
          />
          <meta
            name="keywords"
            content="Agensi properti, cari properti, properti"
          />
          <meta name="author" content="PT Sepakat Menjala Berkat" />
          <meta name="robots" content="index, follow" />
          <title>Sepakat Menjala Berkat</title>
          <link rel="icon" href="./assets/images/favicon.png" />
        </head>
        <body>
          {/* <!-- Jumbotron Section --> */}
          <div className={`${style.jumbotron} jumbotron jumbotron-fluid`}>
            <div className={`${style.container} container`}>
              <h1>Syarat & Ketentuan</h1>
            </div>
          </div>
          {/* <!-- End Jumbotron --> */}

          {/* <!-- Main Section --> */}
          <main>
            <div className={`${style.container} container`}>
              <div className="poin-1">
                <p>
                  Selamat datang di website Sepakat. Dengan mengakses dan
                  menggunakan situs web ini, Anda setuju untuk mematuhi dan
                  terikat oleh ketentuan penggunaan dan kebijakan privasi yang
                  berlaku terkait dengan PT Sepakat Menjala Berkat sehubungan
                  dengan situs web ini.
                </p>
                <h1>1. PENGGUNAAN WEBSITE</h1>
                <p>
                  Dengan mengakses dan menggunakan website www.sepakat.co.id
                  atau aplikasi SEPAKAT PROPERTI sebagai pengunjung dan pengguna
                  terdaftar, Anda menyetujui Syarat dan Ketentuan Umum yang
                  ditetapkan untuk layanan website ini. Ketentuan Umum ini dapat
                  diubah dan/atau diperbarui dan/atau ditambah sewaktu-waktu
                  tanpa pemberitahuan. Jika pengunjung, pengguna terdaftar, agen
                  properti atau penjual/penyewa tidak menyetujui Syarat dan
                  Ketentuan ini, www.sepakat.co.id akan menghentikan akses dan
                  penggunaan situs web www.sepakat.co.id ini. www.sepakat.co.id
                  adalah situs Properti Indonesia yang menghubungkan agen
                  dan/atau penjual SEPAKAT PROPERTI dan pembeli atau penyewa
                  dengan penyewa.
                </p>
              </div>
              <div className="poin-2">
                <h1>2. LAYANAN WEBSITE DAN APLIKASI SEPAKAT</h1>
                <p>
                  Pengguna dan/atau Pengunjung Terdaftar menerima dan menyetujui
                  bahwa www.sepakat.co.id memiliki hak eksklusif untuk mengubah
                  dan/atau menghentikan penyediaan Situs Web dan Aplikasi
                  beserta layanannya atau menghapus sementara atau permanen data
                  Pengguna Terdaftar tanpa pemberitahuan dan tanpa persetujuan
                  sebelumnya. Pengguna terdaftar sebelumnya di www.sepakat.co.id
                  dan/ Aplikasi SEPAKAT PROPERTI tidak memiliki kewajiban kepada
                  pengguna terdaftar untuk penanganan hak eksklusif tersebut.
                  www.sepakat.co.id tidak bertanggung jawab atas penghapusan
                  data, ketidakakuratan data dan/atau kesalahan dalam penyediaan
                  data dan/atau informasi yang disampaikan kepada
                  www.sepakat.co.id
                </p>
              </div>
              <div className="poin-3">
                <h1>3. REGISTRASI / PENDAFTARAN PENGGUNA</h1>
                <p>
                  Untuk dapat menggunakan fungsionalitas penuh dari website
                  www.sepakat.co.id, pengguna harus registrasi atau mendaftar
                  sebagai pengguna terdaftar sebagai agen SEPAKAT PROPERTI dan
                  wajib memberikan data dan/atau informasi dimana pengguna, pada
                  saat pendaftaran, dianggap telah menyetujui dan menerima
                  ketentuan umum yang berlaku pada situs www.sepakat.co.id
                </p>
              </div>
              <div className="poin-4">
                <h1>4. PENGISIAN DAN PUBLIKASI</h1>
                <p>
                  Pengguna terdaftar yang telah memasukkan dan mengunggah data
                  atau informasi terkait penjualan dan/atau persewaan properti
                  di website www.sepakat.co.id dan/ Aplikasi SEPAKAT PROPERTI
                  setuju bahwa www.sepakat.co.id berhak menampilkan dan
                  menggunakan serta menyetujuinya, terus-menerus atau sementara
                  mereproduksi, memodifikasi, mengubah, mengadaptasi,
                  menerbitkan dan mendistribusikan semua atau sebagian dari data
                  atau informasi yang berkaitan dengan properti tanpa kewajiban
                  untuk membayar royalti hak cipta
                </p>
              </div>
              <div className="poin-5">
                <h1>5. KEWAJIBAN PENGGUNA TERDAFTAR</h1>
                <p>
                  Meskipun, kami mengetahui dan memiliki akses ke Informasi
                  Pribadi yang anda kirimkan dengan sukarela ke Situs kami,
                  seperti, namun tidak terbatas pada, kata sandi, alamat email,
                  dan nomor telepon, kami berharap anda bertanggung jawab secara
                  pribadi untuk menjaga kerahasiaan informasi ini, dan untuk
                  bertanggung jawab atas semua informasi yang dipublikasikan,
                  dan aktivitas yang dilakukan dengan menggunakan akun anda
                  dengan kata sandi anda. Kami tidak dapat dimintakan
                  pertanggungjawaban atas konten yang dikirimkan oleh anda atau
                  orang lain yang bertindak atas nama anda ke Situs kami. Namun,
                  kami berhak untuk memantau dan memeriksa informasi yang anda
                  kirimkan ke Situs. Kami memiliki hak untuk menyensor,
                  menghapus, atau melarang pengiriman informasi yang dianggap
                  perlu untuk tujuan melindungi properti dan hak-hak Pinhome.
                  Anda akan secara pribadi bertanggung jawab atas gugatan yang
                  terkait dengan pencemaran nama baik, pelanggaran kekayaan
                  intelektual, privasi, atau gugatan-gugatan lain yang timbul
                  dari konten anda. Atas hal-hal tersebut, SEPAKAT PROPERTI
                  berhak, atas kebijakan tunggalnya, untuk memberikan
                  upaya-upaya perbaikan yang dianggap perlu. Pilihan upaya-upaya
                  perbaikan tersebut termasuk penolakan Layanan, pengakhiran
                  keanggotaan, penghapusan atau pengubahan konten, pembatalan
                  pemesanan, atau menolak akses ke Situs dan ke semua Layanan
                  kami, di dalam atau di luar Situs.
                </p>
              </div>
              <div className="poin-6">
                <h1>6. PENGHAPUSAN TAUTAN DARI WEBSITE KAMI</h1>
                <p>
                  Jika Anda menemukan tautan apa pun di Situs Web kami yang
                  menyinggung karena alasan apa pun, Anda bebas untuk
                  menghubungi dan memberi tahu kami kapan saja. Kami akan
                  mempertimbangkan permintaan untuk menghapus tautan tetapi kami
                  tidak berkewajiban untuk atau lebih atau untuk menanggapi Anda
                  secara langsung.
                </p>
              </div>
            </div>
          </main>
          {/* <!-- End Main --> */}

          <Footer2Component />
        </body>
      </html>
    </>
  );
};

export default SyaratKetentuan;
